import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { setLoading } from 'redux/actions/Auth';
import {
  GET_FEED_CUT_OFF_HISTORY,
  GET_FEED_MANUAL_PRICE_HISTORY,
  SET_CUT_OFF,
  SET_SOURCE_FEED_MANUAL_PRICE,
  SET_TOMEI_PRICE_MANUAL_PRICE,
  SET_TOMEI_PRICE_ADJUSTMENT,
} from 'redux/constants/FeedPrice';
import fetch, { errorHandler } from 'auth/FetchInterceptor';
import setNotification from 'components/shared-components/Notification';
import { env } from 'configs/EnvironmentConfig';
import {
  setFeedCutOffHistory,
  setFeedManualPriceHistory,
} from 'redux/actions/FeedPrice';
import { setCircuitBreakerConfig } from 'redux/actions/FeedConfig';

export function* setSourceFeedManualPrice() {
  yield takeLatest(SET_SOURCE_FEED_MANUAL_PRICE, function* (action) {
    try {
      yield put(setLoading(true));

      // Make the API call to update manual price
      yield call(() => {
        return fetch({
          method: 'post',
          url: env.API_ENDPOINT_URL + '/source-feeds/set-manual-price',
          data: action.payload,
          withCredentials: true,
        });
      });

      // Show success notification immediately
      setNotification({
        message: 'Price switched successfully',
        type: 'success',
      });
    } catch (error) {
      errorHandler(error, 'Failed to switch price');
    } finally {
      // Clear loading state immediately after API call
      yield put(setLoading(false));
    }
  });
}

export function* setTomeiPriceManualPrice() {
  yield takeLatest(SET_TOMEI_PRICE_MANUAL_PRICE, function* (action) {
    try {
      yield put(setLoading(true));

      // Make the API call to update manual price
      yield call(() => {
        return fetch({
          method: 'post',
          url: env.API_ENDPOINT_URL + '/tomei-prices/set-manual-price',
          data: action.payload,
          withCredentials: true,
        });
      });

      // Show success notification immediately
      setNotification({
        message: 'Price switched successfully',
        type: 'success',
      });
    } catch (error) {
      errorHandler(error, 'Failed to switch price');
    } finally {
      // Clear loading state immediately after API call
      yield put(setLoading(false));
    }
  });
}

export function* setCutOff() {
  yield takeLatest(SET_CUT_OFF, function* (action) {
    try {
      yield put(setLoading(true));
      yield call(() => {
        return fetch({
          method: 'post',
          url: env.API_ENDPOINT_URL + '/source-feeds/cut-off-feed',
          data: action.payload,
          withCredentials: true,
        });
      });
      const response = yield call(() => {
        return fetch({
          method: 'post',
          url:
            env.API_ENDPOINT_URL + '/source-feeds/get-circuit-breaker-config',
          data: action.payload,
          withCredentials: true,
        });
      });
      yield put(setCircuitBreakerConfig(response.data.SourceFeedConfig));
      setNotification({
        message: 'Cut off switched successfully',
        type: 'success',
      });
    } catch (error) {
      // setNotification({
      //   message: 'Failed to switch cut off',
      //   type: 'error',
      //   description: error?.response?.data?.message || '',
      // });
      errorHandler(error, 'Failed to switch cut off');
    } finally {
      yield put(setLoading(false));
    }
  });
}

export function* getFeedManualPriceHistory() {
  yield takeLatest(GET_FEED_MANUAL_PRICE_HISTORY, function* (action) {
    try {
      yield put(setLoading(true));
      const response = yield call(() => {
        return fetch({
          method: 'post',
          url:
            env.API_ENDPOINT_URL +
            '/feed-prices/get-feed-manual-price-histories',
          data: action.payload,
          withCredentials: true,
        });
      });
      yield put(setFeedManualPriceHistory(response.data));
    } catch (error) {
      // setNotification({
      //   message: 'Failed to get manual price history',
      //   type: 'error',
      //   description: error?.response?.data?.message || '',
      // });
      errorHandler(error, 'Failed to get manual price history');
    } finally {
      yield put(setLoading(false));
    }
  });
}

export function* getFeedCutOffHistory() {
  yield takeLatest(GET_FEED_CUT_OFF_HISTORY, function* (action) {
    try {
      yield put(setLoading(true));
      if (action.payload.Search.ActivationTrigger == 'All') {
        delete action.payload.Search.ActivationTrigger;
      }
      const response = yield call(() => {
        return fetch({
          method: 'post',
          url:
            env.API_ENDPOINT_URL + '/source-feeds/get-feed-cut-off-histories',
          data: action.payload,
          withCredentials: true,
        });
      });
      yield put(setFeedCutOffHistory(response.data));
    } catch (error) {
      // setNotification({
      //   message: 'Failed to get cut off history',
      //   type: 'error',
      //   description: error?.response?.data?.message || '',
      // });
      errorHandler(error, 'Failed to get cut off history');
    } finally {
      yield put(setLoading(false));
    }
  });
}

export function* setTomeiPriceAdjustment() {
  yield takeLatest(SET_TOMEI_PRICE_ADJUSTMENT, function* (action) {
    try {
      yield put(setLoading(true));
      yield call(() => {
        return fetch({
          method: 'post',
          url: env.API_ENDPOINT_URL + '/tomei-prices/setup-price-adjustments',
          data: action.payload,
          withCredentials: true,
        });
      });
      setNotification({
        message: 'Price adjustment saved successfully',
        type: 'success',
      });
    } catch (error) {
      // setNotification({
      //   message: 'Failed to save price adjustment',
      //   type: 'error',
      //   description: error?.response?.data?.message || '',
      // });
      errorHandler(error, 'Failed to save price adjustment');
    } finally {
      yield put(setLoading(false));
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(setSourceFeedManualPrice),
    fork(setTomeiPriceManualPrice),
    fork(getFeedManualPriceHistory),
    fork(getFeedCutOffHistory),
    fork(setCutOff),
    fork(setTomeiPriceAdjustment),
  ]);
}
